<template>
  <v-pagination
    style="background: #fff;"
    :color="$theme.secondary"
    total-visible="7"
    circle
    class="fonte-subtitulo fonte-italica"
    :elevation="0"
    v-model="get_produtos_filtros.page"
    :length="get_produtos.totalPages"
    @input="setPage($event)"
  ></v-pagination>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters(["get_produtos", "get_produtos_filtros"])
  },
  methods: {
    ...mapActions(["listar_produtos"]),
    setPage(page) {
      if (page) {
        console.log("page", page);
        this.get_produtos_filtros.page = page;
        this.listar_produtos();
      }
    }
  }
};
</script>
